import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import slotDefinition from "slotworks/model/slot-definition";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";

export function ChangeMatrixFreespinsCommand(freespins: boolean = false) {

    const scene = freespins ? "freespins" : "default";

    const layers: Layers[] = [
        Layers.MatrixBackground,
        Layers.MatrixForeground,
        Layers.SymbolAnimations
    ];

    layers.forEach((layer) => layer.setScene(scene).execute());

    lightningBorderAnimationUtil.stop();

    Components.matrix.change(scene, slotDefinition.matrixGrid, null, slotDefinition.reelsets.get(freespins ? "freespins" : "base"));
}
